import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { openMainModal, closeMainModal } from '../../store/actions/profileActions';
import { logout } from '../../store/actions/authActions';
import { SessionWarningProps } from '../../types/session';

const SessionWarning: React.FC<SessionWarningProps> = ({
  isOpen,
  timeLeft,
  onExtendSession,
  onClose,
  openMainModal,
  logout,
}) => {
  const navigate = useNavigate();

  const handleExtendSession = useCallback(() => {
    onExtendSession();
    onClose();
  }, [onExtendSession, onClose]);

  const handleLogout = useCallback(() => {
    logout(false, navigate);
    onClose();
  }, [logout, onClose, navigate]);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  React.useEffect(() => {
    if (isOpen) {
      openMainModal({
        title: 'Sesión por expirar',
        body: `Tu sesión expirará en ${formatTime(timeLeft)}. ¿Deseas extender tu sesión?`,
        confirmHandler: handleExtendSession,
        noHandler: handleLogout,
        yesLabel: 'Extender sesión',
        noLabel: 'Cerrar sesión',
        iconType: 'warning',
        dismiss: false,
        isSuccess: false,
        noActionNeeded: false,
      });
    }
  }, [isOpen, timeLeft, openMainModal, handleExtendSession, handleLogout]);

  return null;
};

const mapDispatchToProps = {
  openMainModal,
  closeMainModal,
  logout,
};

export default connect(null, mapDispatchToProps)(SessionWarning);
